import React from 'react'
// import { ReactComponent as CloseIcon } from 'presentation/assets/icons/close-arrow.svg'
import { ReactComponent as AccordionArrow } from 'presentation/assets/icons/accordion-arrow.svg'

import CardNew from '../CardNew'
import SupportTextNew from '../SupportTextNew'
import Divider from '../DividerNew'

import * as S from './styles'

type AccordionProps = {
  items: {
    title: string | React.ReactElement
    content: React.ReactElement
    disabled?: boolean
  }[]
  padding?: string
  defaultExpanded?: boolean
  display?: string
}

const Accordion = ({
  items,
  padding,
  defaultExpanded,
  display
}: AccordionProps) => {
  return (
    <CardNew shadow="none" padding={padding}>
      {items.map((item, index) => (
        <S.StyledAccordion
          key={index}
          elevation={0}
          disabled={item.disabled}
          defaultExpanded={defaultExpanded}
        >
          <S.StyledAccordionSummary
            expandIcon={<AccordionArrow />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            {React.isValidElement(item.title)
              ? item.title
              : typeof item.title === 'string' && (
                  <SupportTextNew
                    color="primary600"
                    weight="bold"
                    size="medium"
                  >
                    {item.title}
                  </SupportTextNew>
                )}
          </S.StyledAccordionSummary>
          <S.StyledAccordionDetails style={{ display }}>
            <Divider marginTop="0px" />
            {item.content}
          </S.StyledAccordionDetails>
        </S.StyledAccordion>
      ))}
    </CardNew>
  )
}

export default Accordion
